import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const HeroSection = ({ currentHero, heroImages, imgBase, setCurrentHero }) => (
  <section id="inicio" className="relative flex min-h-screen items-center overflow-hidden bg-white pt-36 md:pt-44 lg:pt-52">
    <div className="absolute right-0 top-0 -z-10 hidden h-full w-1/2 bg-slate-50 lg:block" />
    <div className="container mx-auto grid items-center gap-12 px-6 lg:grid-cols-2">
      <div className="animate-in slide-in-from-left space-y-8 fade-in duration-1000">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-700">
          Las Palmas de Gran Canaria
        </div>
        <h1 className="text-6xl font-black leading-[0.9] tracking-tighter text-slate-900 lg:text-8l">
          CUERPO <br /> <span className="text-emerald-600">&amp;</span> SALUD <br /> CONSCIENTE
        </h1>
        <p className="max-w-md text-lg leading-relaxed text-slate-600">
          Bienvenido al espacio de Richard Atik, donde la tradición de las artes marciales y la
          eficacia del Método Balance se encuentran.
        </p>
        <div className="flex flex-wrap gap-4 pt-4">
          <Link
            to={{ pathname: '/', hash: '#disciplinas' }}
            className="flex items-center gap-2 rounded-xl bg-slate-900 px-8 py-4 text-sm font-bold uppercase tracking-widest text-white shadow-xl shadow-slate-200 transition-all hover:bg-emerald-700"
          >
            Disciplinas <ChevronRight size={16} />
          </Link>
          <Link
            to={{ pathname: '/', hash: '#terapias' }}
            className="rounded-xl border-2 border-slate-200 px-8 py-4 text-sm font-bold uppercase tracking-widest transition-all hover:border-slate-900"
          >
            Terapias Naturales
          </Link>
        </div>
      </div>

      <div className="group relative">
        <div className="relative w-full aspect-[4/5] rotate-1 overflow-hidden rounded-[3rem] bg-slate-100 shadow-2xl transition-transform duration-700 hover:rotate-0">
          {heroImages.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Richard Atik ${idx}`}
              className={`absolute inset-0 h-full w-full object-cover grayscale transition-all duration-1000 ${
                currentHero === idx
                  ? 'z-10 scale-105 opacity-100 pointer-events-auto group-hover:grayscale-0'
                  : 'z-0 scale-100 opacity-0 pointer-events-none'
              }`}
              onError={(e) => {
                e.target.src =
                  'https://images.unsplash.com/photo-1552072805-2a9039d00e57?auto=format&fit=crop&q=80&w=1000';
              }}
            />
          ))}
          <div className="absolute bottom-6 right-6 z-20 flex gap-2">
            {heroImages.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentHero(idx)}
                className={`transition-all ${
                  currentHero === idx ? 'h-2 w-6 rounded-full bg-white' : 'h-2 w-2 rounded-full bg-white/40'
                }`}
              />
            ))}
          </div>
        </div>
        <div className="absolute -bottom-8 -left-8 z-30 max-w-[240px] rounded-3xl border border-slate-100 bg-white p-8 shadow-2xl">
          <img src={`${imgBase}logo_balance.png`} className="mb-4 h-8 object-contain" alt="Logo Balance" />
          <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.2em] text-emerald-600">
            Nuestro Método
          </p>
          <p className="text-xl font-black uppercase leading-tight tracking-tighter text-slate-900">
            Método Balance®
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
